/**
 * Visual indicator that the current extraction is locked by another user.
 *
 * Renders nothing if the lock is held by the current user, expired, or absent.
 */
interface LockBadgeProps {
  lockedById?: string | null;
  lockedByEmail?: string | null;
  lockExpiresAt?: string | null;
  currentUserId: string;
}

export function LockBadge({
  lockedById,
  lockedByEmail,
  lockExpiresAt,
  currentUserId,
}: LockBadgeProps) {
  if (!lockedById || lockedById === currentUserId || !lockExpiresAt) return null;

  const expires = new Date(lockExpiresAt);
  if (Number.isNaN(expires.getTime()) || expires <= new Date()) return null;

  const hh = expires.getHours().toString().padStart(2, '0');
  const mm = expires.getMinutes().toString().padStart(2, '0');
  const label = `${lockedByEmail ?? 'autre utilisateur'} jusqu'à ${hh}:${mm}`;

  return (
    <span
      title={`Verrouillé par ${label}`}
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-800 border border-amber-200"
    >
      <span aria-hidden>🔒</span>
      <span className="truncate max-w-[180px]">{label}</span>
    </span>
  );
}
